// After a deploy, a tab opened on the previous build still points at its
// hashed chunks, which are gone. Lazy routes then fail with "Failed to fetch
// dynamically imported module" or "Unable to preload CSS" until the user
// refreshes. Vite reports both as vite:preloadError; reload to pick up the
// new build. A reload within the last minute means the chunk is really
// missing, so let the error through instead of looping. Without usable
// session storage there is no way to tell, so don't reload at all.
const RELOADED_AT = "chunk-reload-at";
const RETRY_AFTER_MS = 60_000;

type ReloadWindow = Pick<Window, "addEventListener" | "sessionStorage"> & {
  location: Pick<Location, "reload">;
};

export function installChunkReload(win: ReloadWindow = window) {
  win.addEventListener("vite:preloadError", (event) => {
    try {
      const last = Number(win.sessionStorage.getItem(RELOADED_AT)) || 0;
      if (Date.now() - last < RETRY_AFTER_MS) return;
      win.sessionStorage.setItem(RELOADED_AT, String(Date.now()));
    } catch {
      // Storage blocked or full: the guard can't be recorded, and reloading
      // without it could loop forever on a chunk that is really missing.
      return;
    }
    event.preventDefault();
    win.location.reload();
  });
}
